import { render, staticRenderFns } from "./AllocationChannelList.vue?vue&type=template&id=caa4adf4&scoped=true&"
import script from "./AllocationChannelList.vue?vue&type=script&lang=js&"
export * from "./AllocationChannelList.vue?vue&type=script&lang=js&"
import style0 from "./AllocationChannelList.vue?vue&type=style&index=0&id=caa4adf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa4adf4",
  null
  
)

export default component.exports